import {observable} from 'mobx';

import TimeRange from '../TimeRange';
import BackendFactory from '../../Services/BackendFactory';

export default class FlightOfferAvailability {

  @observable dayAvailabilities: any = {};
  @observable target_date: string;
  @observable start: string;
  @observable end: string;
  @observable dates: Array<string>;
  @observable times: Array<TimeRange>;

  constructor(json?: any) {
    if(json) {
      this.dates = json.dates;
      this.start = json.start;
      this.end = json.end;
      this.target_date = json.target_date;
      this.times = (json.times || []).map(t => new TimeRange(t));
    }
  }

  static async find(flightOfferId: string, aircraftId: string, targetDate?: string, startDate?: string, endDate?: string): FlightOfferAvailability {
    const backend = await BackendFactory();
    const res = await backend.get(
      `/offer/${flightOfferId}/availability${targetDate ? '/' + targetDate : ''}`,
      {
        start: startDate,
        end: endDate,
        flight_offer_aircraft_id: aircraftId
      }
    );

    if(res.ok) {
      return new FlightOfferAvailability(res.data);
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/FlightOffer/FlightOfferAvailability.js